import { PlayCircleIcon, ThreeDTourIcon } from '../../../ui/icons';
import * as styles from './photoGallery.styles';

type MobileGalleryButtonsProps = {
  hasVideos?: boolean;
  has3dTour?: boolean;
  onVideosClick?: () => void;
  on3dTourClick?: () => void;
};

export const MobileGalleryButtons = ({
  hasVideos,
  has3dTour,
  onVideosClick,
  on3dTourClick,
}: MobileGalleryButtonsProps) => {
  if (!hasVideos && !has3dTour) return null;

  return (
    <div className={styles.mobileOverlayButtons}>
      {hasVideos && onVideosClick && (
        <button
          className={styles.mobileOverlayButton}
          onClick={(e) => {
            e.stopPropagation();
            onVideosClick();
          }}
          aria-label="View videos"
        >
          <PlayCircleIcon />
          Videos
        </button>
      )}
      {has3dTour && on3dTourClick && (
        <button
          className={styles.mobileOverlayButton}
          onClick={(e) => {
            e.stopPropagation();
            on3dTourClick();
          }}
          aria-label="View 3D tours"
        >
          <ThreeDTourIcon />
          3D tours
        </button>
      )}
    </div>
  );
};
